import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/beauty-bg.png'
import _imports_1 from '@/assets/empty.png'


const _withScopeId = n => (_pushScopeId("data-v-20dd1834"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"100%","height":"auto"}
}, null, -1))
const _hoisted_2 = { class: "num-con" }
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = {
  class: "money",
  style: {"font-size":"5vw"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"4vw"} }, "可用股本", -1))
const _hoisted_6 = { style: {"padding":"5vw 0"} }
const _hoisted_7 = {
  class: "money-con",
  style: {"border-right":"1px solid #a58a00"}
}
const _hoisted_8 = { class: "money one-hide" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"3vw"} }, "已消费", -1))
const _hoisted_10 = { class: "money-con" }
const _hoisted_11 = { class: "money one-hide" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"3vw"} }, "快速释放", -1))
const _hoisted_13 = { class: "all-con" }
const _hoisted_14 = { class: "main-con" }
const _hoisted_15 = { class: "white-radius item-con" }
const _hoisted_16 = { class: "cls-con title" }
const _hoisted_17 = { style: {"flex":"1"} }
const _hoisted_18 = { class: "item-desc" }
const _hoisted_19 = {
  key: 0,
  class: "item-desc"
}
const _hoisted_20 = { class: "item-desc" }
const _hoisted_21 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"70vw","height":"auto"}
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-tip" }, "暂无明细记录", -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, "￥" + _toDisplayString(_ctx.data.ableMoney), 1),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: "12" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, "￥" + _toDisplayString(_ctx.data.usedMoney), 1),
                    _hoisted_9
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, { span: "12" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, "￥" + _toDisplayString(_ctx.data.releasedMoney), 1),
                    _hoisted_12
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, "累计充值股本：￥" + _toDisplayString(_ctx.data.allMoney), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_van_list, {
        loading: _ctx.loading,
        "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
        finished: _ctx.finished,
        error: _ctx.error,
        "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.error) = $event)),
        "error-text": "加载失败，点击重试",
        onLoad: _ctx.req_items
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(item.title), 1),
                _createElementVNode("div", null, _toDisplayString(item.changeMoney), 1)
              ]),
              _createElementVNode("div", _hoisted_18, "订单编号：" + _toDisplayString(item.orderCode), 1),
              (item.remarks)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 备注内容：" + _toDisplayString(item.remarks), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_20, "入账时间：" + _toDisplayString(item.createDate), 1)
            ]))
          }), 256))
        ]),
        _: 1
      }, 8, ["loading", "finished", "error", "onLoad"]),
      (!_ctx.list.length&&!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_24))
        : _createCommentVNode("", true)
    ])
  ], 64))
}